import { render, staticRenderFns } from "./relacaoexames.vue?vue&type=template&id=c68a00a0&scoped=true"
import script from "./relacaoexames.vue?vue&type=script&lang=js"
export * from "./relacaoexames.vue?vue&type=script&lang=js"
import style0 from "./relacaoexames.vue?vue&type=style&index=0&id=c68a00a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a00a0",
  null
  
)

export default component.exports